import { createContext } from "react";

export const MedidasContext = createContext()
export const MedidasFormContext = createContext()
export const MedidasReportContext = createContext()